module.exports = __webpack_public_path__ + "img/Rectangle 1233-compressed.c6816f56.jpg";